import React, {useState} from "react";
import {Button, Modal} from "react-bootstrap";

export const AmazonCategory = ({onClose, categories}) => {
    const [show, setShow] = useState(true);
    const handleClose = () => {
        setShow(false);
        onClose();
    };
    return <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>カテゴリ</Modal.Header>
        <Modal.Body>
            {categories.join(' > ')}
        </Modal.Body>
        <Modal.Footer>
            <Button variant="primary" onClick={handleClose}>
                閉じる
            </Button>
        </Modal.Footer>
    </Modal>;
};